import { ArrowRightIcon } from "@heroicons/react/24/outline";
import { ImportResumeComponent } from "components/ImportResumeComponent";
import { ResumeDropzone } from "./ResumeDropzone";
import { useAppSelector } from "lib/redux/hooks";
import { selectResume } from "lib/redux/resumeSlice";
import {
  selectIsImportComponentOpen,
  setImportComponentOpen,
  toggleImportComponent,
} from "lib/redux/settingsSlice";
import Image from "next/image";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Link from "next/link";

export const UploadResume = ({setHasUploadedResume}: {
  setHasUploadedResume: React.Dispatch<React.SetStateAction<boolean>>
}) => {
  const [accessToken, setAccessToken] = useState<string | null>(null);
  const [hasAddedResume, setHasAddedResume] = useState(false);

  const onFileUrlChange = (fileUrl: string) => {
    setHasAddedResume(Boolean(fileUrl));
  };

  useEffect(() => {
    const token = localStorage.getItem("access-token");
    setAccessToken(token);
  });
  const dispatch = useDispatch();
  const toggleImportComponentState = () => {
    dispatch(toggleImportComponent()); // Dispatching the action to toggle the state
  };
  return (
    <div className="mx-auto flex h-[min(400px,90vw)] w-[min(400px,90vw)] sm:h-[min(400px,60vw)] sm:w-[min(400px,60vw)] items-center justify-center rounded-full bg-white font-montserrat drop-shadow-lg md:h-[min(450px,60vw)] md:w-[min(450px,60vw)] lg:h-[min(550px,45vw)] lg:w-[min(550px,45vw)] xl:h-[min(650px,40vw)] xl:w-[min(650px,40vw)] 2xl:h-[min(700px,35vw)] 2xl:w-[min(700px,35vw)]">
      <button
        onClick={toggleImportComponentState}
        className="flex w-[60%] h-[60%] cursor-pointer items-center justify-center rounded-full bg-[#F8F8FF] drop-shadow-lg hover:bg-gray-200"
      >
        <div className="flex flex-col items-center justify-center w-full h-full text-center">
          <ResumeDropzone 
            onFileUrlChange={onFileUrlChange} 
            setHasAddedResume={setHasUploadedResume}
          />
        </div>
      </button>
      {accessToken && (
        <Link href="/dashboard" className="absolute bottom-5 xs:bottom-5 sm:bottom-5 text-xs xs:text-xs flex items-center rounded-full bg-[#9ecad3] px-3 py-1.5 xs:px-4 xs:py-2 font-semibold text-white shadow-md hover:shadow-lg md:bottom-8 md:px-5 md:py-2.5 md:text-sm lg:bottom-6 lg:px-6 lg:py-3 lg:text-base xl:bottom-8 xl:px-8 xl:py-4 xl:text-lg">
          Select from Dashboard
        </Link>
      )}
    </div>
  );
};
